"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styledCell = exports.defaultSortableHeader = exports.defaultHeader = exports.defaultColumnDef = void 0;
var _Cell = require("../../cell/Cell.styled");
var _react = _interopRequireDefault(require("react"));
var _SortableHeaderCell = _interopRequireDefault(require("./SortableHeaderCell"));
var _IconTooltip = _interopRequireDefault(require("../../../../feedback/tooltip/IconTooltip"));
var _jsxRuntime = require("react/jsx-runtime");
var styledCell = function styledCell(props, value) {
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Cell.StyledCell, {
    align: props.align,
    children: value
  });
};
exports.styledCell = styledCell;
var instanceOfSortableColumn = function instanceOfSortableColumn(_o) {
  return true;
};
var defaultColumnDef = function defaultColumnDef(props, exportFormatter, excludeFromExport) {
  var id = props.id,
    header = props.header,
    exportHeader = props.exportHeader,
    hideHeader = props.hideHeader,
    groupingValue = props.groupingValue,
    width = props.width,
    visible = props.visible,
    dataCy = props['data-cy'];
  var isSortable = instanceOfSortableColumn(props) && props.allowSorting;
  return {
    id: id,
    meta: {
      header: header,
      exportHeader: exportHeader,
      hideHeader: hideHeader,
      exportFormatter: exportFormatter || props.exportFormatter,
      width: width,
      visible: visible,
      dataCy: dataCy,
      excludeFromExport: excludeFromExport
    },
    getGroupingValue: groupingValue ? function (row) {
      return groupingValue(row);
    } : undefined,
    header: hideHeader ? undefined : isSortable ? defaultSortableHeader(props) : defaultHeader(props)
  };
};
exports.defaultColumnDef = defaultColumnDef;
var defaultSortableHeader = function defaultSortableHeader(props) {
  var align = props.align,
    header = props.header,
    allowSorting = props.allowSorting;
  if (allowSorting) {
    return function (_ref) {
      var column = _ref.column;
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_SortableHeaderCell.default, {
        column: column,
        align: align,
        onSortChange: props.onSortChange,
        children: header
      });
    };
  } else {
    return defaultHeader(props);
  }
};
exports.defaultSortableHeader = defaultSortableHeader;
var defaultHeader = function defaultHeader(props) {
  var align = props.align,
    header = props.header,
    headerTooltip = props.headerTooltip;
  return function () {
    return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Cell.StyledCell, {
      align: align,
      children: [header, headerTooltip && /*#__PURE__*/(0, _jsxRuntime.jsx)(_IconTooltip.default, {
        iconSize: 'm',
        children: headerTooltip
      })]
    });
  };
};
exports.defaultHeader = defaultHeader;